module.exports = __webpack_public_path__ + "static/media/phonovation.4df01b1a.png";